import { Route } from '@angular/router';
import { AppUrls } from '../../../../../common/dto/app-urls';
import { BannersRoute } from './banners/banners.routes';
import { PopupsRoute } from './popups/popups.routes';

export const AnnounceRoute: Route = {
  path: AppUrls.Dashboard._.Announce.relativeUrl,
  children: [
    PopupsRoute,
    BannersRoute,
    {
      path: '**',
      redirectTo: PopupsRoute.path,
    },
  ],
};
